import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { formatDate } from '@/utils/helpers';

type DayGridCellWrapperProps = PropsWithChildren<{
  column: SchedulerDayColumn;
}>;

export const DayGridCellWrapper = ({ column, children }: DayGridCellWrapperProps) => {
  const { date, isCurrentMonth, isSelectedDay } = column;

  return (
    <div
      className={cn('flex flex-col gap-3 border-b border-e border-base-70 min-h-[140px]', {
        'bg-info-90': isSelectedDay,
      })}
    >
      <div className="flex items-center h-[17px] mx-2 mt-2 justify-end">
        <span
          className={cn('text-s-sb', isCurrentMonth ? 'text-base-20' : 'text-base-30', {
            'text-base-5': isSelectedDay,
          })}
        >
          {formatDate(date, 'd MMM')}
        </span>
      </div>
      {children}
    </div>
  );
};
